export const ClientValidation = (formData) => {
  const errors = {};
  debugger;
  // Validate each field
  if (!formData.CompanyName.trim() && formData.CompanyName.trim() === "") {
    errors.CompanyName = 'This field is required';
  }
  if (formData.VersionID === "0" || formData.VersionID === 0) {
    errors.VersionID = 'This field is required';
  }
  if (!formData.StartDate.trim() && formData.StartDate.trim() === "") {
    errors.StartDate = 'This field is required';
  }
  if (!formData.EndDate.trim() && formData.EndDate.trim() === "") {
    errors.EndDate = 'This field is required';
  }

  if (!formData.Email.trim() && formData.Email.trim() === "") {
    errors.Email = 'This field is required';
  } else if (!isValidEmail(formData.Email)) {
    errors.Email = 'Please enter a valid email address';
  }

  if (!formData.UserName.trim() && formData.UserName.trim() === "") {
    errors.UserName = 'This field is required';
  }
  if (!formData.UserPassword.trim() && formData.UserPassword.trim() === "") {
    errors.UserPassword = 'This field is required';
  }
  // Add more validations as needed for other fields

  return errors;
};

const isValidEmail = (email) => {
  // You can implement a regex or use a library like validator.js to validate email format
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};